import React from 'react';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import {
  GDSStyleObject,
  StackLayout,
  Box,
  ParagraphText,
  HeadingText,
  UtilityText,
} from '@leagueplatform/genesis-core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { FORMS_LIBRARY_ASSET_KEYS } from '../../../types/forms-library.types';

export function NoFormAvailable() {
  const navigate = useNavigate();
  const noFormIcon = useStaticAsset(FORMS_LIBRARY_ASSET_KEYS.NO_FORM_AVAILABLE);

  const goBack = () => {
    navigate(-1);
  };

  return (
    <StackLayout
      horizontalAlignment="center"
      css={
        {
          maxWidth: '490px',
          margin: '0 auto',
        } as GDSStyleObject
      }
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '$three',
            padding: '$two $none',
            '@mobile': { padding: '$two $oneAndHalf' },
            '@tablet': { padding: '$two $oneAndHalf' },
            '@mobileLandscape': { padding: '$two $oneAndHalf' },
          } as GDSStyleObject
        }
      >
        <img src={noFormIcon as string} alt="Visual Icon" height="176px" />
        <HeadingText
          level="3"
          size={{
            '@initial': 'lg',
          }}
          css={
            {
              marginTop: '20px',
            } as GDSStyleObject
          }
        >
          No forms available
        </HeadingText>
        <ParagraphText
          css={
            {
              margin: '24px 0',
              textAlign: 'center',
            } as GDSStyleObject
          }
        >
          There are no forms to display at this time due to your coverage
          details. For further assistance, please reach out to our support team
          via the phone number on the back of your ID card.
        </ParagraphText>
        <UtilityText
          css={{
            color: '#0074C9',
            cursor: 'pointer',
          }}
          onClick={goBack}
        >
          Go Back
        </UtilityText>
      </Box>
    </StackLayout>
  );
}
